import { MenuItem } from './menu.model';

/** Hide menu entries gated by environment (e.g. SBU when categories are disabled). */
export function isMenuItemEnvVisible(
  item: MenuItem,
  isCategoryAllowed?: boolean,
  showArchivedMenu?: boolean,
  showMyfiles?: boolean,
  isLocationAndTagManagementEnabled?: boolean
): boolean {
  if (item.requiresCategoryAllowed === true) {
    return isCategoryAllowed === true;
  }
  if (item.requiresArchivedMenuEnabled === true) {
    return showArchivedMenu !== false;
  }
  if (item.requiresMyFilesEnabled === true) {
    return showMyfiles !== false;
  }
  if (item.requiresLocationAndTagManagementEnabled === true) {
    return isLocationAndTagManagementEnabled === true;
  }
  return true;
}

export const MENU: MenuItem[] = [
  {
    id: 100001,
    label: 'Dashboard',
    labelKey: 'APPMENU.Dashboard',
    // icon: 'home', // previous filled home glyph
    icon: 'home',
    link: '/main/home/dashboard',
    access: ['VIEW_DASHBOARD'],
  },
  {
    id: 100002,
    label: 'My Files',
    labelKey: 'APPMENU.My Files',
    icon: 'my-files',
    link: '/main/home/files',
    access: ['VIEW_MY_FILES'], //['VIEW_FOLDER_HIERARCHY'],
    isFolder: true,
    requiresMyFilesEnabled: true,
    subItems: [],
  },
  {
    id: 100014,
    label: 'Department Assets',
    labelKey: 'APPMENU.Department Assets',
    // icon: 'my-files',
    icon: 'dept-assets',
    isOrgAsset: true,
    isFolder: true,
    link: '/main/home/dept-assets',
    access: ['VIEW_ASSETS'],
    subItems: [],
  },
  {
    id: 100003,
    label: 'Tasks',
    labelKey: 'APPMENU.Tasks',
    // icon: 'task',
    icon: 'tasks',
    link: '/main/home/tasks',
    subItems: [],
    access: ['VIEW_TASKS_MENU'],
  },
  {
    id: 100004,
    label: 'Documents',
    labelKey: 'APPMENU.Documents',
    // icon: 'my-files',
    icon: 'documents',
    link: '/main/home/document-page',
    access: ["VIEW_DOCUMENTS_MENU"], // no dedicated menu permission yet; hidden unless full access
    subItems: [],
  },
  {
    id: 100006,
    label: 'Categories',
    labelKey: 'APPMENU.Categories',
    // icon: 'categories',
    icon: 'category',
    link: '/main/admin-config/document-category',
    access: ['VIEW_CATEGORIES_MENU'],
  },
  {
    id: 100007,
    label: 'Reviews',
    labelKey: 'APPMENU.Reviews',
    // icon: 'review',
    icon: 'reviews',
    link: '/main/home/reviews',
    access: ['VIEW_REVIEWS_MENU'],
  },
  {
    id: 100008,
    label: 'Favourites',
    labelKey: 'APPMENU.Favourites',
    icon: 'favorites',
    link: '/main/home/favourites',
    access: ['VIEW_FAVOURITES'],
  },
  {
    id: 100009,
    label: 'Recycle bin',
    labelKey: 'APPMENU.Recycle bin',
    icon: 'recycle-bin',
    link: '/main/home/recycle-bin',
    access: ['VIEW_RECYCLEBIN'],
  },
  {
    id: 100010,
    label: 'Archived',
    labelKey: 'APPMENU.Archived',
    // icon: 'recycle-bin',
    icon: 'archived',
    link: '/main/home/archived',
    access: ['VIEW_MY_FOLDER'], //'VIEW_FOLDER_HIERARCHY'
    requiresArchivedMenuEnabled: true,
  },
  {
    id: 100011,
    label: 'User Management',
    labelKey: 'APPMENU.User Management',
    // icon: 'user_management',
    icon: 'user-solid',
    link: '/main/user-management',
    access: ['VIEW_USER_MANAGEMENT_MENU'],
  },
  {
    id: 100012,
    label: 'Workflow',
    labelKey: 'APPMENU.Workflow',
    // icon: 'workflow',
    icon: 'workflows',
    link: '/main/admin-config/workflow',
    access: ['VIEW_WORKFLOW_MENU'],
  },
  {
    id: 100022,
    label: 'Workflow Groups',
    labelKey: 'APPMENU.WorkflowGroups',
    // icon: 'workflow',
    icon: 'workflow-groups',
    link: '/main/admin-config/workflow-group',
    access: ['VIEW_WORKFLOW_GROUP_MENU'],
  },
];

export const BOTTOM_MENU: MenuItem[] = [
  // {
  //   id: 99,
  //   label: 'Users',
  //   icon: 'roles',
  //   link: '/main/users/users',
  //   access: ['VIEW_USER'],
  // },
  // {
  //   id: 101,
  //   label: 'Roles',
  //   icon: 'roles',
  //   link: '/main/roles/roles',
  //   access: ['VIEW_ROLE'],
  // },
  {
    id: 100013,
    label: 'Settings',
    labelKey: 'APPMENU.Settings',
    icon: 'settings',
    link: '',
    // link: '/main/admin-config',
    access: [
      'VIEW_SETTINGS_MENU',
      'VIEW_DEPARTMENT',
      'VIEW_ROLE',
      'VIEW_EXTENSION',
      'VIEW_APPCONFIG',
      'VIEW_STYLES',
      'VIEW_EMAIL_TEMP',
      'VIEW_LOOKUP',
      'VIEW_TAG',
      'VIEW_TEMPLATE',
    ],
    isFolder: true,
    subItems: [
      {
        id: 100025,
        label: 'Activity Log',
        labelKey: 'APPMENU.Activity Log',
        // icon: 'lookups',
        icon: 'activity-log',
        link: '/main/admin-settings/activity-log',
        isSubItem: true,
        parentId: 100,
        access: ['VIEW_SETTINGS_MENU'],
      },
      {
        id: 100015,
        label: 'Department',
        labelKey: 'APPMENU.Department',
        icon: 'department',
        link: '/main/admin-config/department',
        isSubItem: true,
        parentId: 100, // Added parentId for consistency
        access: ['VIEW_DEPARTMENT'],
      },
      {
        id: 100016,
        label: 'Roles',
        labelKey: 'APPMENU.Roles',
        icon: 'roles',
        link: '/main/admin-config/roles',
        isSubItem: true,
        parentId: 100, // Added parentId for consistency
        access: ['VIEW_ROLE'],
      },
      {
        id: 100017,
        label: 'Application Configuration',
        labelKey: 'APPMENU.Application Configuration',
        icon: 'settings',
        link: '/main/admin-config/application-configuration',
        isSubItem: true,
        parentId: 100,
        access: ['VIEW_APPCONFIG'],
      },
      {
        id: 100026,
        label: 'Style Settings',
        labelKey: 'APPMENU.Style Settings',
        icon: 'settings',
        link: '/main/admin-config/style-settings',
        isSubItem: true,
        parentId: 100,
        access: ['VIEW_STYLES'],
      },
      {
        id: 100023,
        label: 'Tag Management',
        labelKey: 'APPMENU.Tag Management',
        icon: 'tag',
        link: '/main/admin-settings/tags',
        isSubItem: true,
        parentId: 100,
        access: ['VIEW_TAG'],
        requiresLocationAndTagManagementEnabled: true,
      },
      {
        id: 100027,
        label: 'Supported File Extensions',
        labelKey: 'APPMENU.Supported File Extensions',
        icon: 'supported-file-extensions',
        link: '/main/admin-settings/supported-file-extensions',
        isSubItem: true,
        parentId: 100,
        access: ['VIEW_EXTENSION'],
      },
      {
        id: 100018,
        label: 'Email Templates',
        labelKey: 'APPMENU.Email Templates',
        icon: 'email-template',
        link: '/main/admin-config/templates',
        isSubItem: true,
        parentId: 100,
        access: ['VIEW_EMAIL_TEMP'],
      },
      {
        id: 100020,
        label: 'Document Template',
        labelKey: 'APPMENU.Document Template',
        icon: 'templates',
        link: '/main/admin-config/template',
        isSubItem: true,
        parentId: 100,
        access: ['VIEW_TEMPLATE'],
      },
      {
        id: 100021,
        label: 'Signature',
        labelKey: 'APPMENU.Signature',
        icon: 'signature',
        link: '/main/admin-config/signature',
        isSubItem: true,
        parentId: 100,
        access: ['VIEW_SETTINGS_MENU'],
      },
      {
        id: 100019,
        label: 'Lookup',
        labelKey: 'APPMENU.Lookup',
        icon: 'lookups',
        link: '/main/admin-config/lookup-classification',
        isSubItem: true,
        parentId: 100,
        access: ['VIEW_LOOKUP'],
      },
    ],
  },
  // {
  //   id: 100024,
  //   label: 'Help & Information',
  //   icon: 'help',
  //   link: '',
  //   // access: ['VIEW_HELP_INFO'],
  // },
];
